import React, { FunctionComponent } from 'react'
import { ImageResizeMode, ImageSourcePropType } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { IS_WEB } from '../../constants'
import { useGetResponsiveAssets } from '../../hooks/useGetResponsiveAssets'
import { getAssetSource, ThemeType } from '../../utils'

const BackgroundImage = styled.ImageBackground<{ theme: ThemeType }>(({ theme }) => ({
  width: '100%',
  height: '100%',
  ...(IS_WEB && theme.breakpoints.isMobileSized && { padding: `0 ${theme.spacing['24px']}` }),
  // sizes from laptop up to (but not including) desktop
  ...(theme.breakpoints.isMinWidthLaptop && !theme.breakpoints.isMinWidthDesktop && { padding: '0 100px' }),
  // sizes from tablet up to (but not including) laptop
  ...(theme.breakpoints.isMinWidthTablet &&
    !theme.breakpoints.isMinWidthLaptop && { padding: `0 ${theme.spacing['48px']}` }),
}))

export interface CloudBackgroundImageProps {
  children?: React.ReactNode
}

export const CloudBackgroundImage: FunctionComponent<CloudBackgroundImageProps> = ({ children }) => {
  const {
    assets: { cloudBackground },
  } = useTheme() as ThemeType

  const backgroundImageUrl = useGetResponsiveAssets(cloudBackground.assetNames)
  const backgroundImageSrc = getAssetSource(backgroundImageUrl)

  const backgroundImageProps = {
    resizeMode: 'stretch' as ImageResizeMode,
    source: backgroundImageSrc as ImageSourcePropType,
  }

  return <BackgroundImage {...backgroundImageProps}>{children}</BackgroundImage>
}
